import type { InternalConversation } from '@/models/internalChat'
import type { User } from '@/models/user'
import { ROLES, USER_STATUS } from '@/shared/constants'

type UserWithRole = Pick<User, 'role' | 'roleId'>

export function canManageUsers(user?: UserWithRole | null) {
  const roleId = user?.role?.id ?? user?.roleId

  return roleId !== ROLES.ATTENDANT && roleId !== ROLES.SPECIALIST
}

export function isActiveUser(user?: Pick<User, 'status'> | null) {
  return user?.status === USER_STATUS.ACTIVE
}

export function userBelongsToDepartment(
  user: Pick<User, 'departmentIds' | 'departments'>,
  departmentId: string | number
) {
  const normalizedDepartmentId = departmentId.toString()

  return Boolean(
    user.departmentIds?.some(
      (currentId) => currentId.toString() === normalizedDepartmentId
    ) ||
      user.departments?.some(
        (department) => department.id.toString() === normalizedDepartmentId
      )
  )
}

function isInactiveUser(user?: Pick<User, 'status'> | null) {
  return user?.status === USER_STATUS.INACTIVE
}

export function isVisibleInternalConversationForUser(
  conversation: InternalConversation,
  currentUser?: Pick<User, 'id'> | null
) {
  if (conversation.isGroup) {
    return true
  }

  const recipients = conversation.participants.filter(
    (participant) => participant.userId !== currentUser?.id
  )

  if (!recipients.length) {
    return true
  }

  return recipients.some((participant) => !isInactiveUser(participant.user))
}
